var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatFile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 27,
    viewBox: "0 0 30 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18090_119488)",
    filter: "url(#filter0_d_18090_119488)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 12,
    r: 12,
    fill: "#E4E4E5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9882 6.6001C19.3877 6.6001 19.7115 6.92395 19.7115 7.32344V16.36C19.7115 16.7594 19.3877 17.0833 18.9882 17.0833H11.5241C11.1246 17.0833 10.8008 16.7594 10.8008 16.36V7.32344C10.8008 6.92395 11.1246 6.6001 11.5241 6.6001H18.9882ZM16.0038 13.8696H12.6177C12.4006 13.8696 12.2246 14.0456 12.2246 14.2627C12.2246 14.4798 12.4006 14.6558 12.6177 14.6558H16.0038C16.2209 14.6558 16.3969 14.4798 16.3969 14.2627C16.3969 14.0456 16.2209 13.8696 16.0038 13.8696ZM17.9069 11.3916H12.6177C12.4006 11.3916 12.2246 11.5676 12.2246 11.7847C12.2246 12.0018 12.4006 12.1778 12.6177 12.1778H17.9069C18.124 12.1778 18.3 12.0018 18.3 11.7847C18.3 11.5676 18.124 11.3916 17.9069 11.3916ZM17.8721 8.91815H12.5829C12.3658 8.91815 12.1898 9.09416 12.1898 9.31127C12.1898 9.52838 12.3658 9.70439 12.5829 9.70439H17.8721C18.0892 9.70439 18.2652 9.52838 18.2652 9.31127C18.2652 9.09416 18.0892 8.91815 17.8721 8.91815Z",
    fill: "#9FA0A7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_18090_119488",
    x: -1,
    y: 0,
    width: 32,
    height: 32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_18090_119488"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_18090_119488",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18090_119488"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatFile);
export default __webpack_public_path__ + "static/media/chat-file.48685caef492cf8cc29ea3fb4fd77d6c.svg";
export { ForwardRef as ReactComponent };